import { at } from 'lodash';
import moment from 'moment';

import {
  getFormFieldLabel,
  getFormFieldName,
  validateEmail,
  validateMobilePhone,
} from 'utils';
import { BookingFormModel, ViewBookingsFormModel } from './bookingFormModel';
import { VERIFY_CODE_LENGTH } from 'common/enum';

const {
  s4_firstNameF,
  s4_lastNameF,
  s4_mobilePhoneF,
  s4_emailF,
  s5_emailMobileF,
  s5_verificationCodeF,
  s4_DOBF,
  s4_isReturnC,
  s4_voucherF,
  s4_employerF,
  s1_onlineServiceF,
} = BookingFormModel;

export const bookingValidate = values => {
  const errors = {
    s4: { patient: {}, contact: {}, billing: {} },
    s5: {},
  };

  const [
    firstName,
    lastName,
    email,
    mobilePhone,
    emailMobile,
    verificationCode,
    dob,
    isReturn,
    voucher,
    employer,
    onlineServiceId,
  ] = at(
    values,
    s4_firstNameF.name,
    s4_lastNameF.name,
    s4_emailF.name,
    s4_mobilePhoneF.name,
    s5_emailMobileF.name,
    s5_verificationCodeF.name,
    s4_DOBF.name,
    s4_isReturnC.name,
    s4_voucherF.name,
    s4_employerF.name,
    s1_onlineServiceF.name,
  );

  /**
   *
   * [
        {
          "id": 3,
          "name": "Skin Check"
        },
        {
          "id": 7,
          "name": "Flu Vaccine"
        },
        {
          "id": 8,
          "name": "Workplace Skin Check"
        }
      ]
  */
  // ref: https://redisys.atlassian.net/browse/MOL-316
  if (onlineServiceId === 8 && voucher && !employer) {
    errors.s4[getFormFieldName(s4_employerF.name)] = `${getFormFieldLabel(
      s4_employerF.label,
    )} is a required field`;
  }

  if (!firstName) {
    errors.s4.patient[
      getFormFieldName(s4_firstNameF.name)
    ] = `${getFormFieldLabel(s4_firstNameF.label)} is a required field`;
  }
  if (!lastName) {
    errors.s4.patient[
      getFormFieldName(s4_lastNameF.name)
    ] = `${getFormFieldLabel(s4_lastNameF.label)} is a required field`;
  }
  if (!dob) {
    errors.s4.patient[getFormFieldName(s4_DOBF.name)] = `${getFormFieldLabel(
      s4_DOBF.label,
    )} is a required field`;
  } else if (moment(`${dob}`).isAfter(moment(), 'day')) {
    errors.s4.patient[getFormFieldName(s4_DOBF.name)] = `${getFormFieldLabel(
      s4_DOBF.label,
    )} is invalid`;
  }
  if (!email) {
    const errMsg = `Please fill ${getFormFieldLabel(s4_emailF.label)}`;

    errors.s4.contact[getFormFieldName(s4_emailF.name)] = errMsg;
  } else if (!validateEmail(email)) {
    errors.s4.contact[getFormFieldName(s4_emailF.name)] = `${getFormFieldLabel(
      s4_emailF.label,
    )} is invalid`;
  }

  if (!mobilePhone) {
    const errMsg = `Please fill ${getFormFieldLabel(s4_mobilePhoneF.label)}`;

    errors.s4.contact[getFormFieldName(s4_mobilePhoneF.name)] = errMsg;
  } else if (!validateMobilePhone(mobilePhone)) {
    errors.s4.contact[
      getFormFieldName(s4_mobilePhoneF.name)
    ] = `${getFormFieldLabel(s4_mobilePhoneF.label)} is invalid`;
  }

  if (!emailMobile) {
    errors.s5[getFormFieldName(s5_emailMobileF.name)] = `${getFormFieldLabel(
      s5_emailMobileF.label,
    )} is a required field`;
  } else {
    if (!verificationCode) {
      errors.s5[
        getFormFieldName(s5_verificationCodeF.name)
      ] = `${getFormFieldLabel(
        s5_verificationCodeF.label,
      )} is a required field`;
    } else {
      if (emailMobile.indexOf('@') > -1) {
        if (verificationCode < VERIFY_CODE_LENGTH.EMAIL) {
          errors.s5[
            getFormFieldName(s5_verificationCodeF.name)
          ] = `${getFormFieldLabel(s5_verificationCodeF.label)} is invalid`;
        }
      } else {
        if (verificationCode < VERIFY_CODE_LENGTH.MOBILE) {
          errors.s5[
            getFormFieldName(s5_verificationCodeF.name)
          ] = `${getFormFieldLabel(s5_verificationCodeF.label)} is invalid`;
        }
      }
    }
  }
  if (isReturn === undefined) {
    errors.s4[getFormFieldName(s4_isReturnC.name)] = `${getFormFieldLabel(
      s4_isReturnC.label,
    )} is a required field`;
  }

  return errors;
};

const {
  firstNameF,
  lastNameF,
  mobilePhoneF,
  emailF,
  DoBF,
} = ViewBookingsFormModel;

export const viewBookingsValidate = values => {
  const errors = { patient: {} };

  const [firstName, lastName, email, mobilePhone, dob] = at(
    values,
    firstNameF.name,
    lastNameF.name,
    emailF.name,
    mobilePhoneF.name,
    DoBF.name,
  );

  if (!firstName) {
    errors.patient[getFormFieldName(firstNameF.name)] = `${getFormFieldLabel(
      firstNameF.label,
    )} is a required field`;
  }
  if (!lastName) {
    errors.patient[getFormFieldName(lastNameF.name)] = `${getFormFieldLabel(
      lastNameF.label,
    )} is a required field`;
  }
  if (!dob) {
    errors.patient[getFormFieldName(DoBF.name)] = `${getFormFieldLabel(
      DoBF.label,
    )} is a required field`;
  } else if (moment(`${dob}`).isAfter(moment(), 'day')) {
    errors.patient[getFormFieldName(DoBF.name)] = `${getFormFieldLabel(
      DoBF.label,
    )} is invalid`;
  }
  if (!email && !mobilePhone) {
    const errMsg = `Please fill ${getFormFieldLabel(
      emailF.label,
    )} or ${getFormFieldLabel(mobilePhoneF.label)}`;

    errors.patient[getFormFieldName(emailF.name)] = errMsg;
    //errors.patient[getFormFieldName(mobilePhoneF.name)] = errMsg;
  } else {
    if (email && !validateEmail(email)) {
      errors.patient[getFormFieldName(emailF.name)] = `${getFormFieldLabel(
        emailF.label,
      )} is invalid`;
    }
    if (mobilePhone && !validateMobilePhone(mobilePhone)) {
      errors.patient[
        getFormFieldName(mobilePhoneF.name)
      ] = `${getFormFieldLabel(mobilePhoneF.label)} is invalid`;
    }
  }

  return errors;
};
